export default "__VITE_ASSET__DzU4KhqE__"